module.exports = __webpack_public_path__ + "static/media/iconCantineMenuYellow.5f3fd5e0.svg";